var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _ellipse3, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon, _path15, _polygon2, _path16, _path17, _path18, _path19, _circle, _path20, _path21, _path22, _circle2, _path23, _path24, _rect7, _rect8, _rect9, _path25, _path26, _circle3, _path27, _path28, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeStuff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 938.10702,
    height: 598.78003,
    viewBox: "0 0 938.10702 598.78003",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768.78349,749.39H646.12333c-.79-.78-1.56982-1.57-2.33984-2.38a131.38615,131.38615,0,0,1-20.58008-28.13c-13-23.96-18.22021-51.81-10.78027-77.68.18994-.66.38037-1.32.59033-1.98.3999.61.81006,1.22,1.23,1.82a183.51854,183.51854,0,0,0,18.48975,23.03c.51025.56,1.04,1.12,1.58008,1.67a191.55136,191.55136,0,0,0,57.62011,40.95q7.22974,3.345,14.73975,6.05c3.88037,1.41,7.82031,2.68,11.79,3.82,16.67041,4.77,35.71,8.34,45.58008,22.59a32.64808,32.64808,0,0,1,3.98,7.86005C768.31328,747.79,768.56328,748.59,768.78349,749.39Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M736.50322,747.01a27.05721,27.05721,0,0,1,2.1499,2.38H736.2332a25.91309,25.91309,0,0,0-2.41992-2.38,20.87554,20.87554,0,0,0-9.39014-4.7,30.24425,30.24425,0,0,0-6.83985-.56c-4.54.1-9.12011.95-13.60009,1.46-1.12989.13-2.25977.23-3.37989.29a40.91978,40.91978,0,0,1-17.21-2.43c-6.85986-2.6-13.02-6.86005-18.58007-11.59q-5.37012-4.56-10.27979-9.66l-1.26025-1.32a166.48572,166.48572,0,0,1-40.8501-77.3c-.12988-.55005-.25-1.11-.36963-1.67-.24023-1.15,1.58008-1.31,1.81982-.17.12012.56.23975,1.12.37012,1.68a162.40918,162.40918,0,0,0,11.68994,34.01c.25.56.50977,1.11.79,1.65a161.48229,161.48229,0,0,0,28.33985,40.99c.10986.13.23.25.35986.38q4.03491,4.215,8.39014,8.12c5.46,4.89,11.43017,9.37,18.16992,12.34a39.07786,39.07786,0,0,0,17.68017,3.21c.6001-.02,1.21-.06,1.81983-.11.48-.04.96-.08,1.45019-.13,4.58008-.49,9.2002-1.35,13.83008-1.54a35.69411,35.69411,0,0,1,6.27979.26A23.599,23.599,0,0,1,736.50322,747.01Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M655.21246,719.27085a24.42528,24.42528,0,0,1-31.62788-.142c-.88738-.76606.26135-2.181,1.1499-1.41391a22.61731,22.61731,0,0,0,29.42081.072c.8933-.75931,1.94537.729,1.05717,1.484Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M699.60864,742.29824A47.07781,47.07781,0,0,0,690.181,709.31c-.71214-.9326.77267-1.98865,1.484-1.05717A48.96792,48.96792,0,0,1,701.40549,742.6c-.11434,1.16913-1.91057.861-1.79685-.30177Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M625.43686,675.34235a13.8259,13.8259,0,0,0,7.21333-10.9581c.09947-1.17,1.89567-.86061,1.79685.30177a15.493,15.493,0,0,1-7.953,12.14028.94162.94162,0,0,1-1.27057-.21339.91561.91561,0,0,1,.21339-1.27056Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M802.31328,748.64l-.54981.75H721.39335c-.41015-.79-.81982-1.58-1.22021-2.38q-1.33447-2.61008-2.58985-5.26c-.27978-.58-.56982-1.17-.81982-1.78v-.01a177.16787,177.16787,0,0,1-10.09033-27.21v-.01a156.1537,156.1537,0,0,1-3.46973-15.52,130.62112,130.62112,0,0,1-.41015-40.88c.01025-.07.02-.14.03027-.21,4.0498-26.96,16.6499-52.33,38.1499-68.51.00977-.01.00977-.01.02-.01.54981-.42,1.08984-.81,1.64014-1.22-.04.73-.08008,1.44-.11035,2.17v.04a181.84586,181.84586,0,0,0,.89013,29.51v.01c.06983.76.16016,1.52.25,2.28v.01a191.988,191.988,0,0,0,21.35987,67.36.00988.00988,0,0,0,.01025.01,184.72737,184.72737,0,0,0,15.25,23.85c7.8501,10.44,17.18994,21.12,21.02979,33.18.24023.73.45019,1.46.64013,2.2C802.08329,747.55,802.20341,748.1,802.31328,748.64Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M776.60331,749.39h-1.85986c-.04-.8-.10986-1.59-.22021-2.38a21.2942,21.2942,0,0,0-5-11.23c-4.54981-5.19-11.02-8.14-16.85987-11.58-.98-.58-1.93994-1.18005-2.87011-1.81a40.73,40.73,0,0,1-12.29-12.3c-3.89991-6.21-6.25-13.32-7.8501-20.44a138.22889,138.22889,0,0,1-2.37988-13.9c-.08985-.6-.16016-1.21-.21973-1.82a166.14564,166.14564,0,0,1,13.93994-86.32c.21973-.52.46-1.04.69971-1.55.49023-1.06,2.04-.09,1.54.96-.23975.51-.48,1.03-.71,1.54a163.26507,163.26507,0,0,0-11.14991,34.22c-.12988.6-.25,1.2-.35986,1.79a161.79169,161.79169,0,0,0-2.06006,49.77c.02.2.04.39.06006.58q.7046,5.79,1.81982,11.5c1.41993,7.19,3.49024,14.36,7.08008,20.79a39.02728,39.02728,0,0,0,12.18018,13.19c.5.36005,1.00976.7,1.52978,1.03.41016.26.81983.52,1.23975.77,5.74023,3.44,12.01025,6.3,16.81006,11.08a23.63462,23.63462,0,0,1,6.70019,13.73A23.35588,23.35588,0,0,1,776.60331,749.39Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M728.13429,675.7159a24.42528,24.42528,0,0,1-25.16758-19.15558c-.24731-1.14591,1.52177-1.584,1.7694-.4366a22.61728,22.61728,0,0,0,23.44752,17.77084c1.17041-.06844,1.11437,1.7533-.04934,1.82134Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M749.71807,720.83155a47.07774,47.07774,0,0,0,12.33372-32.01533c-.00712-1.17339,1.81424-1.12263,1.82135.04935a48.968,48.968,0,0,1-12.90207,33.28876c-.7952.86464-2.04387-.46284-1.253-1.32278Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M730.80813,622.71448a13.82591,13.82591,0,0,0,12.357-4.4065c.78384-.8743,2.03174.45417,1.253,1.32278a15.49307,15.49307,0,0,1-13.65932,4.90507.94162.94162,0,0,1-.886-.93535.91562.91562,0,0,1,.93535-.886Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.40634,
    cy: 7.68935,
    rx: 7.52172,
    ry: 7.68935,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.39048,
    cy: 7.68935,
    rx: 7.52172,
    ry: 7.68935,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.37462,
    cy: 7.68935,
    rx: 7.52172,
    ry: 7.68935,
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M612.70479,155.31331H594.24238a1.3984,1.3984,0,0,1,0-2.79612h18.46241a1.3984,1.3984,0,0,1,0,2.79612Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M612.70479,160.55605H594.24238a1.3984,1.3984,0,0,1,0-2.79612h18.46241a1.3984,1.3984,0,0,1,0,2.79612Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M612.70479,165.79879H594.24238a1.3984,1.3984,0,0,1,0-2.79612h18.46241a1.3984,1.3984,0,0,1,0,2.79612Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M631.957,179.61H131.94649a1,1,0,0,1,0-2H631.957a1,1,0,0,1,0,2Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#cacaca"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 195.45534,
    y: 234.00754,
    width: 105.58192,
    height: 8.67797,
    rx: 4.33898,
    fill: "#b99e7c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 174.84517,
    y: 251.36347,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 174.84517,
    y: 268.7194,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198.45534,
    y: 97.00754,
    width: 105.58192,
    height: 8.67797,
    rx: 4.33898,
    fill: "#b99e7c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 177.84517,
    y: 114.36347,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 177.84517,
    y: 131.7194,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "664.967 573.936 652.149 573.936 646.052 524.497 664.969 524.498 664.967 573.936",
    fill: "#9e616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M802.80842,748.88341h-9.095l-1.62343-8.5868-4.15783,8.5868H763.80991a5.42245,5.42245,0,0,1-3.08122-9.88463L779.992,725.69486v-8.681l20.26162,1.20934Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "783.988 561.181 772.64 567.139 744.258 526.202 761.008 517.408 783.988 561.181",
    fill: "#9e616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M932.35331,730.13311l-8.05254,4.228-5.42911-6.84788.31051,9.53542-21.35729,11.21373a5.42245,5.42245,0,0,1-7.32312-7.31926l10.87068-20.734-4.03553-7.68593,18.50138-8.34832Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M746.92675,250.95438v41.047a118.03811,118.03811,0,0,1,29.075-3.99357,110.763,110.763,0,0,1,20.52351,1.7103q5.067.88508,10.26176,2.28327c7.26039-15.26439,9.55192-29.44268,0-41.047a24.79513,24.79513,0,0,0-24.79925-24.79925H771.726A24.79513,24.79513,0,0,0,746.92675,250.95438Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M872.05414,687.77627,809.2902,578.79514a6.52029,6.52029,0,0,1,.07032-6.58252l26.7223-44.53693a6.51289,6.51289,0,0,1,11.71093,1.13784l53.94319,145.03868a6.48857,6.48857,0,0,1-3.3379,8.09916l-17.90191,8.47939a6.45481,6.45481,0,0,1-2.76368.62051A6.545,6.545,0,0,1,872.05414,687.77627Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M797.12413,710.21365l-26.54138-3.06157a6.51459,6.51459,0,0,1-5.71005-7.32882l23.68794-178.35269a5.07075,5.07075,0,0,0-.09859-1.86154l-23.80879-98.22889a6.43771,6.43771,0,0,1,1.01911-5.309c3.692-5.0899,16.34215-16.95171,53.97147-17.17645h.04064a6.53689,6.53689,0,0,1,5.94575,3.822l5.01957,11.042a5.08807,5.08807,0,0,0,1.694,2.04528c6.909,4.8906,40.37887,32.34154,20.726,92.60895-19.31573,59.23558-44.06377,174.23526-48.82892,196.68677a6.47874,6.47874,0,0,1-6.35212,5.15774A6.65716,6.65716,0,0,1,797.12413,710.21365Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 635.17068,
    cy: 110.44152,
    r: 26.50953,
    fill: "#9e616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M766.78218,414.64435l.29087-3.94222c-.20523-.10262-.41048-.21379-.62426-.34206-11.895-6.8977-26.98831-42.28818-36.46179-67.327a28.73427,28.73427,0,0,1,13.62927-35.63971l.00539-.0028a1.38805,1.38805,0,0,0,.585-.4893l43.74434-8.30137a1.38814,1.38814,0,0,1,.597-.10364l26.80125,1.29228A16.4408,16.4408,0,0,1,830.57989,312.525l8.70267,73.54247c.02973.1326-.34448,1.60248-.27645,1.72009.11663.20158.33323.57542.64316,1.10834.8124,1.40246,2.84886,10.86247,4.76417,14.2745C840.23333,415.8738,785.40834,412.57705,766.78218,414.64435Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "678.456 193.818 688.718 232.3 669.905 261.375 678.456 232.3 678.456 193.818",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M737.0422,421.819l37.62645,27.36468,12.82719-5.986L759.276,419.25359Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#9e616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M749.8694,387.61317l17.95808,35.061-47.03306,6.84117s5.13088-100.05213,7.69632-106.89331a41.61939,41.61939,0,0,1,5.36489-9.03321,14.98973,14.98973,0,0,1,16.01377-5.50427h0Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#e4e4e4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.46185,
    cy: 302.15895,
    r: 11.1169,
    fill: "#9e616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M886.2228,454.69467,657.97946,430.9929a13.26464,13.26464,0,0,0-14.5638,11.82361l-5.70033,54.893a13.26461,13.26461,0,0,0,11.82362,14.5638l3.3501.34789,17.2631,1.79267,207.63014,21.56121a13.26463,13.26463,0,0,0,14.5638-11.82362l5.70033-54.893A13.26464,13.26464,0,0,0,886.2228,454.69467Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#cacaca"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M878.47751,529.27988,650.23415,505.57811a6.54046,6.54046,0,0,1-5.82345-7.17307l5.70035-54.8933a6.54046,6.54046,0,0,1,7.17307-5.82345l173.351,18.00152a61.791,61.791,0,0,1,55.01542,67.76661A6.54045,6.54045,0,0,1,878.47751,529.27988Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 717.1597,
    y: 461.54717,
    width: 105.58192,
    height: 8.67797,
    rx: 4.33898,
    transform: "translate(-78.70748 -227.64548) rotate(5.92859)",
    fill: "#b99e7c"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 694.75686,
    y: 478.81027,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    transform: "translate(-76.93398 -227.36799) rotate(5.92859)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 692.96418,
    y: 496.07337,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    transform: "translate(-75.16048 -227.09049) rotate(5.92859)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M808.97523,414.12271l-28.21984,23.9441,12.8272,5.986L831.209,416.68815Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#9e616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M818.38184,302.95368h0a14.98975,14.98975,0,0,1,16.01377,5.50427,41.61922,41.61922,0,0,1,5.36489,9.03322c2.56544,6.84117,7.69631,106.8933,7.69631,106.8933l-47.033-6.84117,17.95808-35.061Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#e4e4e4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 651.89641,
    cy: 297.02807,
    r: 11.1169,
    fill: "#9e616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M762.31938,232.14116h30.78528v14.53748h3.42058v43.03949a110.763,110.763,0,0,0-20.52351-1.7103c2.73079-10.08492,3.6327-18.9364,3.05857-26.7917H752.49105a15.59244,15.59244,0,0,1-1.14577-8.04283,16.20489,16.20489,0,0,0-3.30158,8.04283H733.24441v-.00005A29.07486,29.07486,0,0,1,762.31938,232.14116Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.05351,748.2a1.18673,1.18673,0,0,1-1.19043,1.19H420.57353a1.19,1.19,0,0,1,0-2.38h647.28955A1.1867,1.1867,0,0,1,1069.05351,748.2Z",
    transform: "translate(-130.94649 -150.60999)",
    fill: "#cacaca"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.40682,
    cy: 119.06403,
    r: 15,
    fill: "#f0f0f0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.40682,
    cy: 261,
    r: 15,
    fill: "#f0f0f0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.40682,
    cy: 312,
    r: 15,
    fill: "#f0f0f0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeStuff);
export default __webpack_public_path__ + "static/media/freeStuff.94aff384caa7f8c40c1ee4f0e1971925.svg";
export { ForwardRef as ReactComponent };